// src/components/Hero.js
import React, { useEffect } from 'react';
import { DASHBOARD_URL } from '../config/urls';
import './Hero.css';

const Hero = () => {
  // Add floating money signs animation
  useEffect(() => {
    const moneySigns = document.querySelector('.money-signs');
    if (moneySigns) {
      // Clear existing content
      moneySigns.innerHTML = '';
      
      // Add money signs with different colors and positions
      for (let i = 0; i < 10; i++) {
        const sign = document.createElement('span');
        const colors = ['green', 'blue', 'white'];
        sign.className = colors[i % 3];
        sign.textContent = '₹';
        sign.style.left = `${10 + (i * 10)}%`;
        sign.style.animationDuration = `${15 + Math.random() * 10}s`;
        sign.style.animationDelay = `${Math.random() * 5}s`;
        moneySigns.appendChild(sign);
      }
    }
  }, []);

  return (
    <section className="hero">
      <div className="bg"></div>
      <div className="hero-content">
        <div className="money-signs"></div>
        <div className="badge">India's Trusted Loan Platform</div>
        <h1>Smart Loan Solutions <span>For Every Need</span></h1>
        <p className="subline">
Low Interest Rates • Disbursal in as little as 24–48 Hours • Minimal Paperwork          </p>
        <p>Fast, seamless personal and business loans designed around your goals, fully digital from application to disbursement.</p>
        
        <div className="actions">
          <a href={DASHBOARD_URL} className="primary">Apply Now</a>
          <a href={DASHBOARD_URL} className="secondary">Check Eligibility</a>
        </div>
        
        <div className="pills">
          {['100% Digital Process', 'Competitive Rates', 'Flexible Tenure', 'Personal & Business Loans'].map((text, i) => (
            <div key={i} className="pill">{text}</div>
          ))}
        </div>
{/* For later */}
        {/* <div className="stats">
          <div className="stat">
            <strong>10,000+</strong>
            <span>Customers Served</span>
          </div>
          <div className="stat">
            <strong>₹500 Cr+</strong>
            <span>Amount Disbursed</span>
          </div>
          <div className="stat">
            <strong>4.8/5</strong>
            <span>Customer Rating</span>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Hero;
